const API = 'https://mixupbr.com.br/api';

export async function get(modulo, params = {}) {
  const query = new URLSearchParams(params).toString();
  const url = `${API}/${modulo}/${query ? '?' + query : ''}`;
  const res = await fetch(url);
  return res.json();
}

export async function post(modulo, body) {
  const res = await fetch(`${API}/${modulo}/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return res.json();
}

export async function put(modulo, id, body) {
  const res = await fetch(`${API}/${modulo}/?id=${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return res.json();
}

export async function del(modulo, id) {
  const res = await fetch(`${API}/${modulo}/?id=${id}`, { method: 'DELETE' });
  return res.json();
}
